var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "kl-footer", attrs: { id: "wrapper" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "kl-footer__wrapper content-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "kl-footer__content",
          staticStyle: { padding: "10px 0" }
        },
        [
          _c("div", { staticClass: "kl-footer__info" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "kl-footer__address" }, [
              _c("p", [_vm._v("Attract, Retain, Mentor for Tomorrow")]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://apps.apple.com/in/app/mentormentee/id1541844880",
                        target: "_blank",
                        rel: "noopener"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            _vm.mmSiteUrl +
                            "hs-fs/hubfs/Mentor_Mentee_May2025/Images/app-store-icon-159x47.png?width=90&height=26&name=app-store-icon-159x47.png",
                          alt: "apple store"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://play.google.com/store/apps/details?id=com.poweredbyu.mentoring",
                        target: "_blank",
                        rel: "noopener"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            _vm.mmSiteUrl +
                            "hs-fs/hubfs/Mentor_Mentee_May2025/Images/google-play-badge-159x47.png?width=90&height=26&name=google-play-badge-159x47.png",
                          alt: "google play store"
                        }
                      })
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(3)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "kl-footer__menu" }, [
            _c("div", { staticClass: "kl-footer__group" }, [
              _c("ul", [
                _vm._m(4),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          _vm.mmSiteUrl + "technical-mentoring-news?hsLang=en"
                      }
                    },
                    [_vm._v("News")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    { attrs: { href: _vm.mmSiteUrl + "contact-us?hsLang=en" } },
                    [_vm._v("Contact Us")]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "kl-footer__group" }, [
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    { attrs: { href: _vm.mmSiteUrl + "product?hsLang=en" } },
                    [_vm._v("Product")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    { attrs: { href: _vm.mmSiteUrl + "faq?hsLang=en" } },
                    [_vm._v("FAQ’s")]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "kl-footer__legal" }, [
        _c("p", { staticStyle: { "text-align": "center" } }, [
          _c("span", [_vm._v("© Mentor Mentee 2025")]),
          _vm._v(" | "),
          _c(
            "a",
            { attrs: { href: _vm.mmSiteUrl + "privacy-policy?hsLang=en" } },
            [_vm._v("Privacy Policy")]
          ),
          _vm._v(" | "),
          _c(
            "a",
            { attrs: { href: _vm.mmSiteUrl + "/terms-of-use?hsLang=en" } },
            [_vm._v("Terms Of Service")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(5)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "widget widget_text btm-pane-wrap",
        attrs: { id: "text-4" }
      },
      [
        _c(
          "div",
          {
            staticClass: "textwidget page-center",
            staticStyle: { "text-align": "center" }
          },
          [
            _c(
              "p",
              { staticStyle: { "font-weight": "bold", margin: "0 0 0 0" } },
              [_vm._v("SUBSCRIBE")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticStyle: { "line-height": "15px", "padding-right": "5px" }
              },
              [
                _vm._v(
                  "Join our email list for exclusive content and the latest news."
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "0 auto", "text-align": "center" } },
              [
                _c(
                  "a",
                  {
                    staticClass: "subscribe_button",
                    staticStyle: {
                      color: "#002F42",
                      "text-decoration": "none"
                    },
                    attrs: {
                      href:
                        "https://mentormentee.myfreshworks.com/crm/sales/web_forms/6023db3e327995f942ef2b9914ec732959b5faf106bcf8ed45381efe06281c45/form.html",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v("Email "),
                    _c("i", { staticClass: "fa fa-arrow-right" })
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#" } }, [
      _c("img", {
        staticStyle: { "max-width": "134px", "max-height": "51px" },
        attrs: {
          src:
            "https://mentormentee.com/hubfs/Mentor_Mentee_May2025/Images/Large_Logo_White.png",
          alt: "Mentor Mentee",
          width: "100%",
          loading: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "margin-bottom": "0px" } }, [
      _c("br"),
      _vm._v("888.800.9250"),
      _c("br"),
      _vm._v("Overland Park, KS")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      {
        staticClass: "kl-footer__social",
        staticStyle: { "margin-left": "0px" }
      },
      [
        _c("li", [
          _c(
            "a",
            {
              staticStyle: {
                color: "#002F42",
                "font-size": "32px",
                "font-weight": "bold"
              },
              attrs: {
                href: "https://www.linkedin.com/company/mentormentee",
                target: "_blank"
              }
            },
            [_c("i", { staticClass: "fa fa-linkedin-square" })]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "https://app.mentormentee.com/mmlogin" } }, [
        _vm._v("Login")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "kl-footer__byline-wrapper" }, [
      _c("div", { staticClass: "content-wrapper" }, [
        _c("div", { staticClass: "kl-footer__byline" }, [
          _c("span", [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.kalungi.com/atlas-hubspot-theme-for-b2b-saas-software"
                }
              },
              [
                _vm._v(
                  "\n           Powered by Atlas - a B2B SaaS HubSpot theme\n           "
                )
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e93bc3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e93bc3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mm_footer.vue
// module id = null
// module chunks = 